import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorSnippet } from '../../../../../_entity/snippet/ModuleFE_AdvisorSnippet.js';
import './Renderer_AdvisorSnippetHeader.scss';
export class Renderer_AdvisorSnippetHeader extends ComponentSync {
    __onAdvisorSnippetsUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.snippet?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ snippet: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.snippet?._id)
            state.snippet = ModuleFE_AdvisorSnippet.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'advisor-snippet-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'advisor-snippet-header__title', children: this.state.snippet?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const snippet = this.state.snippet;
        if (!snippet?.renderedLabel || snippet.renderedLabel === snippet.label)
            return;
        return _jsx("span", { className: 'advisor-snippet-header__sub-title', children: snippet.renderedLabel });
    };
}
//# sourceMappingURL=Renderer_AdvisorSnippetHeader.js.map